<template>
  <app-fieldset title="Leverdatum &amp; datum geldig tot">
    <div>
      <expected-delivery-date
        v-if="showDeliveryDate"
        ref="expectedDeliveryDateBlock"
        :disabled="disable"
      />
    </div>
    <div>
      <do-not-deliver-before v-if="showDoNotDeliverBeforeDate" :disabled="disable" />
    </div>
    <div>
      <expire-date v-if="showExpireDate" ref="expireDateBlock" :disabled="disable" />
    </div>
  </app-fieldset>
</template>

<script>
import moment from 'moment'
import AppFieldset from '@/components/generic/presentational/atoms/appFieldset/AppFieldset.vue'
import AdditionalOrder from '@/mixins/additionalOrder.js'
import { mapState } from 'vuex'
import ExpectedDeliveryDate from '@/components/generic/presentational/molecules/expectedDeliveryDate/ExpectedDeliveryDate.vue'
import DoNotDeliverBefore from '@/components/generic/presentational/molecules/doNotDeliverBefore/DoNotDeliverBefore.vue'
import ExpireDate from '@/components/generic/presentational/molecules/expireDate/ExpireDate.vue'
import { ref } from 'vue'

export default {
  components: {
    AppFieldset,
    ExpectedDeliveryDate,
    DoNotDeliverBefore,
    ExpireDate,
  },
  mixins: [AdditionalOrder],
  props: {
    showDoNotDeliverBeforeDate: {
      type: Boolean,
      default: true,
    },
    showDeliveryDate: {
      type: Boolean,
      default: true,
    },
    showExpireDate: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const expectedDeliveryDateBlock = ref(null)
    const expireDateBlock = ref(null)

    return {
      expectedDeliveryDateBlock,
      expireDateBlock,
    }
  },
  data() {
    return {
      minDate: moment(),
    }
  },
  computed: {
    ...mapState({
      disable(state, getters) {
        return getters[this.quoteNamespace + '/quoteStatusIsSalesOrder']
      },
    }),
  },
  methods: {
    changeDeliveryDate(value) {
      this.expectedDeliveryDateBlock.changeDeliveryDate(value)
    },
    changeExpireDate(value) {
      this.expireDateBlock.changeExpireDate(value)
    },
  },
}
</script>

<style lang="scss" scoped>
:deep() {
  .fields {
    grid-template-columns: repeat(2, 1fr);
  }

  #expireDate-container {
    .label {
      padding-right: 3rem;
    }
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 0.5em;

    div {
      display: flex;
      align-items: center;
      flex: 1;

      div {
        display: block;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
